import React from "react";
import { Spin, Select } from "antd";

import { compose, config, resetFilterHook } from "src/helpers";
import { Field, RenderSelect } from "src/components";

import { withBooks } from "src/modules/book/operations";

import { withStateAndActionsForBook } from "../resolvers";

const Option = Select.Option;

const SubjectsField = (props) => {
    const {
        loading,
        books,
        where,
        onNameChange,
        onChange,
        value,
        onStateReset,
        dropdownOpen,
    } = props;
    resetFilterHook(onStateReset);
    return (
        <Field
            labelInValue
            showSearch={true}
            filterOption={false}
            onSearch={onNameChange}
            notFoundContent={loading ? <Spin size="small" /> : null}
            name={"books"}
            component={RenderSelect}
            placeholder={"Books"}
            value={value || "None"}
            loading={loading}
            onChange={onChange}
            inFilter={true}
            noBotMarging={true}
            mode={"multiple"}
            open={dropdownOpen}
        >
            {[
                // config.EMPTY_OPTION,
                ...(books?.map((book) => ({
                    id: book.id,
                    label: book.title || "",
                    value: book.id,
                })) || []),
            ]?.map(
                ({
                    id,
                    value,
                    label = "",
                }: {
                    id: string;
                    value: string;
                    label: string;
                }) => (
                    <Option key={id} value={value}>
                        {label}
                    </Option>
                ),
            )}
        </Field>
    );
};

export default compose(withStateAndActionsForBook, withBooks)(SubjectsField);
